import { IconList, SpacerWrapper } from '@ahmdigital/ui';
import { map, some } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import { Limits, Service } from '../../types';
import constants from '../../../../../../ahm-constants';
import summariseWaitingPeriods from '../../utils/summarise-waiting-periods';
import TitledCollapse from '../titled-collapse';
import uncapFpIterator from '../../../../../../../utils/uncap-fp-iterator';

const {
  SCALE,
  SERVICE,
  PRODUCT_LIMIT_CATEGORY: { TEETH },
} = constants;

const Wrapper = styled.div`
  width: 100%;
`;

const LineSpacer = styled.div`
  margin-top: 0.75rem;
`;

type CollapsedSectionProps = {
  id: string;
  limits: Limits;
  scale: string;
  services: Service[];
};

const mapWithIndex = uncapFpIterator(map);

const CollapsedSection = ({ id, limits, scale, services }: CollapsedSectionProps) => {
  const isSingleScale = scale === SCALE.SINGLE;
  const hasOrthodontics = some({ id: SERVICE.ORTHODONTICS }, services);

  const orthodonticsLimit = <LineSpacer>${limits.lifetime} Orthodontics lifetime limit per person</LineSpacer>;

  const individualLimits = (
    <>
      ${limits.individual} bundle limit per person
      {hasOrthodontics ? orthodonticsLimit : null}
    </>
  );

  const familyLimits = (
    <>
      ${limits.family} family bundle limit
      <LineSpacer>with a ${limits.individual} bundle limit per person</LineSpacer>
      {hasOrthodontics ? orthodonticsLimit : null}
    </>
  );
  const limitsBody = isSingleScale ? individualLimits : familyLimits;

  const text = mapWithIndex(
    (waitingPeriodSummary: string, index: number) =>
      index === 0 ? (
        <div key={waitingPeriodSummary}>{waitingPeriodSummary}</div>
      ) : (
        <LineSpacer key={waitingPeriodSummary}>{waitingPeriodSummary}</LineSpacer>
      ),
    summariseWaitingPeriods(services),
  );

  const benefitBackText =
    id === TEETH && !hasOrthodontics ? '50% back on included extras' : '60% back on included extras';

  return (
    <Wrapper>
      <TitledCollapse
        body={
          <SpacerWrapper variant="paddingTopSpacer9">
            <IconList
              variant="simple"
              itemSpacerSize={9}
              items={[
                {
                  icon: 'time',
                  text,
                },
                { icon: 'dollar-sign', text: limitsBody },
                { icon: 'percent', text: benefitBackText },
              ]}
            />
          </SpacerWrapper>
        }
        id={id}
        title="Waiting periods, limits & percentage back"
      />
    </Wrapper>
  );
};

export default CollapsedSection;
